import styled from '@emotion/styled';
import { dangerousGettext, gettext } from '@eventbrite/i18n';
import { Checkbox, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppContext } from '../../../AppContext';
import { CreateAccountFormValues } from '../types';

export enum CreateAccountTermsCheckboxTestId {
    Field = 'CreateAccountTermsCheckboxField',
}

export const CreateAccountTermsCheckbox = () => {
    const { control } = useFormContext<CreateAccountFormValues>();
    const { isSubmittingCreateAccountForm } = useAppContext();

    return (
        <Controller
            name="acceptedTerms"
            control={control}
            rules={{
                required: {
                    value: true,
                    message: gettext(
                        'You must accept the terms to proceed.',
                    ).toString(),
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <TermsCheckbox>
                    <Checkbox
                        aria-label={gettext(
                            'I accept the Eventbrite Terms of service.',
                        )}
                        id="termsAccepted"
                        name="termsAccepted"
                        onChange={(val: boolean) =>
                            field.onChange({ target: { value: val } })
                        }
                        checked={field.value}
                        data-testid={CreateAccountTermsCheckboxTestId.Field}
                        disabled={isSubmittingCreateAccountForm}
                    />
                    <Disclaimer>
                        <Typography
                            as="span"
                            color="neutral-800"
                            variant="body-md"
                        >
                            <p
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: dangerousGettext(
                                        'I accept the <a href="%(termsUrl)s" target="_blank">Eventbrite Terms of Service</a> and <a href="%(guidelinesUrl)s" target="_blank">Community Guidelines</a>, and have read the <a href="%(privacyUrl)s" target="_blank">Privacy Policy</a>.',
                                        {
                                            termsUrl: '/tos',
                                            guidelinesUrl:
                                                '/community-guidelines',
                                            privacyUrl: '/privacypolicy',
                                        },
                                    ).toString(),
                                }}
                            />
                        </Typography>
                        {error && <Error>{error.message}</Error>}
                    </Disclaimer>
                </TermsCheckbox>
            )}
        />
    );
};

const TermsCheckbox = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const Disclaimer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 8px;
`;

const Error = styled.div`
    color: red;
    font-size: 12px;
`;
